// This is needed since jQuery doesn't have an ESM distribution. See https://github.com/jashkenas/backbone/issues/4274 for the discussion on this.
import '/assets/scripting/lib/jquery/js/jquery.min.js';

export default window.jQuery.noConflict(true);